import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin-top: 32px;

  && input {
    max-width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
